export default __webpack_public_path__ + "static/media/new-floor-4.77510b3a.svg";